{
  "metadata": {
    "id": "osaka-jade-light",
    "name": "Osaka Jade",
    "description": "Портировано из темы «Osaka Jade» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "osaka-jade.json",
      "project": "opencode",
      "url": "https://github.com/anomalyco/opencode",
      "upstreamFile": "packages/ui/src/theme/themes/osaka-jade.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 24.2,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.448,
      "paletteMaxS": 0.52,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.1,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 18.2,
      "syntaxVsTextMinDeltaE": 18.0,
      "chartsMinDeltaE": 22.5,
      "textSeparationDeltaE": 19.8,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "string",
          "b": "function",
          "deltaE": 0.0
        },
        {
          "a": "string",
          "b": "type",
          "deltaE": 0.0
        },
        {
          "a": "function",
          "b": "type",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#1d9d85",
      "hover": "#1a8d78",
      "active": "#18816d",
      "foreground": "#000000",
      "muted": "#1d9d8580",
      "emphasis": "#1d9d85"
    },
    "surface": {
      "background": "#F6F5DD",
      "foreground": "#111c18",
      "muted": "#c6c8b4",
      "mutedForeground": "#39473e",
      "elevated": "#afb2a0",
      "elevatedForeground": "#111c18",
      "raised": "#929788",
      "raisedForeground": "#111c18",
      "overlay": "#f6f5dd33",
      "subtle": "#dedec8"
    },
    "interactive": {
      "border": "#8b9082",
      "borderHover": "#b6b8a6",
      "borderFocus": "#1d9d85",
      "selection": "#111c1824",
      "selectionForeground": "#111c18",
      "focus": "#1d9d8559",
      "focusRing": "#1d9d8547",
      "cursor": "#111c18",
      "hover": "#111c1817",
      "active": "#111c1824"
    },
    "status": {
      "error": "#c7392d",
      "errorForeground": "#ffffff",
      "errorBackground": "#c7392d1a",
      "errorBorder": "#c7392d59",
      "warning": "#7d6e16",
      "warningForeground": "#ffffff",
      "warningBackground": "#7d6e161a",
      "warningBorder": "#7d6e1659",
      "success": "#3d7a52",
      "successForeground": "#ffffff",
      "successBackground": "#3d7a521a",
      "successBorder": "#3d7a5259",
      "info": "#167b68",
      "infoForeground": "#ffffff",
      "infoBackground": "#167b681a",
      "infoBorder": "#167b6859"
    },
    "pr": {
      "open": "#3d7a52",
      "draft": "#45574c",
      "blocked": "#7d6e16",
      "merged": "#3d7a52",
      "closed": "#c7392d"
    },
    "syntax": {
      "base": {
        "background": "#c6c8b4",
        "foreground": "#111c18",
        "comment": "#39473e",
        "keyword": "#00311f",
        "string": "#2e5b3d",
        "number": "#7b3c5a",
        "function": "#2e5b3d",
        "variable": "#111c18",
        "type": "#2e5b3d",
        "operator": "#5e5311"
      },
      "tokens": {
        "commentDoc": "#39473e",
        "stringEscape": "#5e5311",
        "keywordImport": "#00311f",
        "storageModifier": "#00311f",
        "functionCall": "#2e5b3d",
        "method": "#2e5b3d",
        "variableProperty": "#2e5b3d",
        "variableOther": "#111c18",
        "variableGlobal": "#7b3c5a",
        "variableLocal": "#5e5311",
        "parameter": "#111c18",
        "constant": "#7b3c5a",
        "class": "#2e5b3d",
        "className": "#2e5b3d",
        "interface": "#2e5b3d",
        "struct": "#2e5b3d",
        "enum": "#2e5b3d",
        "typeParameter": "#2e5b3d",
        "namespace": "#2e5b3d",
        "module": "#00311f",
        "tag": "#00311f",
        "jsxTag": "#00311f",
        "tagAttribute": "#2e5b3d",
        "tagAttributeValue": "#2e5b3d",
        "boolean": "#7b3c5a",
        "decorator": "#00311f",
        "label": "#2e5b3d",
        "regexp": "#2e5b3d"
      }
    },
    "charts": {
      "series": [
        "#1d9d85",
        "#166c7b",
        "#266853",
        "#7d6e16",
        "#c7392d"
      ]
    },
    "chat": {
      "background": "#F6F5DD",
      "userMessage": "#111c18",
      "userMessageBackground": "#afb2a0",
      "assistantMessage": "#111c18",
      "assistantMessageBackground": "#c6c8b4",
      "timestamp": "#45574c",
      "divider": "#8b9082",
      "typing": "#45574c"
    },
    "loading": {
      "spinner": "#1d9d85",
      "spinnerTrack": "#c6c8b4",
      "skeleton": "#c6c8b4",
      "shimmer": "#bbbeab"
    },
    "tools": {
      "background": "#c6c8b4",
      "border": "#8b9082",
      "headerHover": "#bdbfac",
      "icon": "#177b68",
      "title": "#111c18",
      "description": "#45574c",
      "edit": {
        "added": "#3d7a52",
        "addedBackground": "#3d7a521a",
        "removed": "#c7392d",
        "removedBackground": "#c7392d1a",
        "modified": "#167b68",
        "modifiedBackground": "#167b681a",
        "lineNumber": "#45574c"
      }
    },
    "markdown": {
      "heading1": "#111c18",
      "heading2": "#111c18",
      "heading3": "#111c18",
      "heading4": "#111c18",
      "link": "#177b68",
      "linkHover": "#177c69",
      "inlineCode": "#2e5b3d",
      "inlineCodeBackground": "#c6c8b4",
      "blockquote": "#45574c",
      "blockquoteBorder": "#8b9082",
      "listMarker": "#1c9981",
      "bold": "#111c18",
      "italic": "#111c18e6",
      "strikethrough": "#45574c",
      "hr": "#8b9082"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#8a393f",
        "foreground": "#ffffff",
        "contrast": 7.67
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#af6740",
        "foreground": "#000000",
        "contrast": 4.84
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#cba560",
        "foreground": "#000000",
        "contrast": 9.09
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#becf67",
        "foreground": "#000000",
        "contrast": 12.31
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#718f42",
        "foreground": "#000000",
        "contrast": 5.71
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#67cc62",
        "foreground": "#000000",
        "contrast": 10.39
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#6bc48b",
        "foreground": "#000000",
        "contrast": 9.89
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#438e78",
        "foreground": "#000000",
        "contrast": 5.38
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#67cdc4",
        "foreground": "#000000",
        "contrast": 11.11
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#3f798c",
        "foreground": "#ffffff",
        "contrast": 4.86
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#6085bd",
        "foreground": "#000000",
        "contrast": 5.59
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#323786",
        "foreground": "#ffffff",
        "contrast": 10.36
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#8057c2",
        "foreground": "#ffffff",
        "contrast": 5.17
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#c75dc5",
        "foreground": "#000000",
        "contrast": 5.8
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#8a3b7b",
        "foreground": "#ffffff",
        "contrast": 7.02
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#c65a81",
        "foreground": "#000000",
        "contrast": 5.18
      }
    ]
  }
}
